import {
  PAGE_ID_DESCRIPTION,
  PAGE_ID_LOADING,
  PAGE_ID_SPEED_COURSE,
  PAGE_ID_RESULTS,
  PAGE_ID_FINISHED,
  PAGE_ID_NO_PAGES,
  TEMPLATE_PICTURESLIDES,
  EmptyArray,
  EmptyObject,
} from '~/utils/constants';
import {getDictionary} from '~/utils/dictionary';
import {createSelector} from 'reselect';
import memoize from 'micro-memoize';
import {DEFAULT_BG_COLOR} from '~/utils/theme.constants';
import {isDark} from '~/styles/utils/utils';

export const getCourseData = ({course: {data}}) => data;
export const selectIsCourseDataEmpty = ({course: {data}}) => !data;
export const getTrackData = ({course: {track: {data}}}) => data;
export const getPages = ({course: {data}}) => data?.pages || EmptyArray;
export const getActivePageId = state => state.course.data?.activePageId;
export const getLastPageId = state => state.course.data?.lastPageId;
export const getCourseId = ({course: {id} = {}}) => id;
export const getPageThumbnails = state => state.course?.thumbnails;
export const getSaveStatus = state => state.course?.saveStatus;
export const getCollectedData = state => state.course?.collectedData;
export const getWinningStreak = state => state.course?.winningStreak;
export const getPageHistory = ({course: {pageHistory}}) => pageHistory;
export const getSco = ({course: {sco}}) => sco;
export const getEvents = ({course: {events}}) => events;
export const getNextPageLoading = ({course: {nextPageLoading}}) => nextPageLoading;
export const getResultsPage = state => state.course?.data?.resultsPage;
export const getActiveSlideId = state => state.course?.data?.activeSlideId;

const selectPagesById = createSelector(
  getPages,
  pages => pages?.length
    ? Object.fromEntries(pages.map(page => [page?.id, page]))
    : EmptyObject,
);

// export const getActivePage = state => getPages(state).find(page => page.id === getActivePageId(state));
export const getPage = createSelector(
  selectPagesById,
  getActivePageId,
  (pages, activePageId) => pages[activePageId],
);

export const selectPageStyles = createSelector(
  getPage,
  page => {
    const {
      bgInputType,
      bgColor = DEFAULT_BG_COLOR,
      bgToColor,
    } = page || {};

    if (!bgColor) return EmptyObject;

    const style = {backgroundColor: bgColor};

    if (bgInputType !== 'solid' && bgToColor) {
      style.background = `linear-gradient(180deg, ${bgColor} 0%, ${bgToColor} 100%)`;
    }

    return {
      backgroundStyle: style,
      navigationButtonColor: isDark(bgToColor || bgColor)
        ? '#fff'
        : '#000',
      statusbarColorscheme: isDark(bgColor) ? 'light' : 'dark',
    };
  },
);


export const getActivePageTxtColor = createSelector(getPage, page => page?.txtColor);

// export const getPageIndex = state => getAllPages(state)?.findIndex(page => page.id === getActivePageId(state));
export const getPageIndex = createSelector(
  getPages,
  getActivePageId,
  (pages, activePageId) => pages?.findIndex?.(page => page.id === activePageId),
);

// export const getAllSlides = state => getPage(state)?.pictureslides?.slides || EmptyArray;
export const getActivePageSlides = createSelector(
  getPage,
  page => page?.pictureslides?.slides || EmptyArray,
);

const getActivePageSlidesById = createSelector(
  getActivePageSlides,
  slides => slides?.length
    ? Object.fromEntries(slides.map(slide => [slide?.id, slide]))
    : EmptyObject,
);

// export const getSlide = state => getAllSlides(state).find(slide => slide.id === getActiveSlideId(state));
export const getActiveSlide = createSelector(
  getActivePageSlidesById,
  getActiveSlideId,
  (slides, activeSlideId) => slides[activeSlideId],
);

// export const getSlideId = state => getSlide(state)?.id;
export const getSlideId = createSelector(getActiveSlide, slide => slide?.id);

// export const getSlideIndex = state => getAllSlides(state)?.findIndex(slide => slide.id === getActiveSlideId(state));
export const getActiveSlideIndex = createSelector(
  getActivePageSlides,
  getActiveSlideId,
  (slides, activeSlideId) => slides?.findIndex?.(slide => slide.id === activeSlideId),
);

// export const getSlideIndex = state => {
//   console.log('GET SLIDE INDEX', {
//     getSlideIndex: _getSlideIndex(state),
//     getActiveSlideIndex: _getActiveSlideIndex(state),
//   });

//   return _getSlideIndex(state);
// };

// export const getActiveSlideIndex = state => {
//   console.log('GET ACTIVE SLIDE INDEX', {
//     getSlideIndex: _getSlideIndex(state),
//     getActiveSlideIndex: _getActiveSlideIndex(state),
//   });

//   return _getActiveSlideIndex(state);
// };


// export const getSlideCount = state => getAllSlides(state)?.length || 0;
export const getSlideCount = createSelector(
  getActivePageSlides,
  slides => slides?.length || 0,
);

// export const getTemplateTypeId = state => getPage(state)?.templateTypeId;
export const getTemplateTypeId = createSelector(
  getPage,
  page => page?.templateTypeId,
);

// export const getCourseHasQuizPage = state => !!getPages(state)?.find(page => page.questionnaire);
export const getCourseHasQuizPage = createSelector(
  getPages,
  pages => !!pages?.some(page => page?.questionnaire),
);

// export const getSpeedCourseIndex = state => getPages(state).findIndex(page => page.id === PAGE_ID_SPEED_COURSE);
export const getSpeedCourseIndex = createSelector(
  getPages,
  pages => pages?.findIndex(page => page?.id === PAGE_ID_SPEED_COURSE),
);

// export const getLayout = state => {
//   const slide = getSlide(state);

//   return slide?.layout || [slide?.columns || 1];
// };
export const getLayout = createSelector(
  getActiveSlide,
  slide => slide?.layout || [slide?.columns || 1],
);

// export const getSettingsData = state => {
//   if (!state.course.data?.settings || !state.course.data?.settings.theme) {
//     const theme = {
//       theme: {
//         color: '#2e77eb',
//         theme: null,
//       },
//     };

//     return theme;
//   }

//   return state.course.data?.settings;
// };

const defaultSettingsData = {
  theme: {
    color: DEFAULT_BG_COLOR,
    theme: null,
  },
};

export const getSettingsData = state => state.course?.data?.settings?.theme
  ? state.course.data.settings
  : defaultSettingsData;


// export const getPageCollectedData = (state, {pageId} = {}) => {
//   if (pageId === PAGE_ID_DESCRIPTION) {
//     return null;
//   }
//   const collectedData = getCollectedData(state);
//   const activePageId = getActivePageId(state);

//   return collectedData && collectedData[activePageId];
// };

export const createCollectedPageDataSelector = memoize(pageId => createSelector(
  getCollectedData,
  getActivePageId,
  (collectedData, activePageId) => {
    if (pageId === PAGE_ID_DESCRIPTION) return null;

    return collectedData?.[activePageId];
  },
));

export const getSpeedCoursePagesCollectedData = state => getPages(state)
  .some(page => page.id === PAGE_ID_SPEED_COURSE)
  ? Object.fromEntries(getPages(state)
    .slice(
      getPages(state).findIndex(page => page.id === PAGE_ID_SPEED_COURSE),
      getPages(state).length,
    )
    .map(page => [page.id, state.course.collectedData[page.id]]))
  : undefined;

// export const getPagesAndSubpagesCount = state => getPages(state)
//   ?.reduce((acc, page) => {
//     if (page?.hideProgress) {
//       return acc;
//     }

//     // for pictureslides, also count the slides of each pictureslide
//     if (page.templateTypeId === TEMPLATE_PICTURESLIDES) {
//       return acc + page.pictureslides?.slides.filter(slide => slide && !slide.hideProgress).length;
//     } else if (page.templateTypeId === PAGE_ID_SPEED_COURSE) {
//       return acc;
//     }

//     return acc + 1;
//   }, 0) || 0;

export const getPagesAndSubpagesCount = createSelector(
  getPages,
  pages => pages?.reduce((acc, page) => {
    if (page?.hideProgress || page?.templateTypeId === PAGE_ID_SPEED_COURSE) return acc;

    // for pictureslides, also count the slides of each pictureslide
    if (page?.templateTypeId === TEMPLATE_PICTURESLIDES) {
      return acc + page.pictureslides?.slides?.filter?.(slide => slide && !slide.hideProgress).length || 0;
    }

    return acc + 1;
  }, 0) || 0,
);

// export const getPageIdSequenceIncludingSubpages = state => {
//   const pages = getPages(state);

//   const pageIds = pages.reduce((acc, page) => {
//     if (page?.hideProgress) {
//       return acc;
//     }

//     // for pictureslides, also count the slides of each pictureslide
//     const pageId = page.id;

//     if (page.templateTypeId === TEMPLATE_PICTURESLIDES) {
//       return [
//         ...acc,
//         ...page.pictureslides?.slides
//           .filter(slide => slide && !slide.hideProgress)
//           .map(({id}) => ({
//             pageId,
//             slideId: id,
//           })) || [],
//       ];
//     } else if (page.templateTypeId === PAGE_ID_SPEED_COURSE) {
//       return acc;
//     }

//     return [...acc, {pageId}];
//   }, []);

//   return pageIds;
// };

export const getPageIdSequenceIncludingSubpages = createSelector(
  getPages,
  pages => pages?.reduce((acc, page) => {
    if (!page?.id || page?.hideProgress || page.templateTypeId === PAGE_ID_SPEED_COURSE) return acc;

    // for pictureslides, also count the slides of each pictureslide
    if (page.templateTypeId === TEMPLATE_PICTURESLIDES) {
      page.pictureslides?.slides?.forEach?.(slide => {
        if (slide && !slide.hideProgress) {
          acc.push({
            pageId: page.id,
            slideId: slide.id,
          });
        }
      });
    } else {
      acc.push({pageId: page.id});
    }

    return acc;
  }, []) || EmptyArray,
);

// export const getPageNumberIncludingSubpages = state => {
//   const pages = getPages(state);
//   const pageIndex = getPageIndex(state);

//   if (pageIndex === -1) {
//     return -1;
//   }

//   const slideIndex = getActiveSlideIndex(state);
//   const pagesAndSubpagesCount = pages.slice(0, pageIndex + 1).reduce((acc, page, index) => {
//     if (!page || page.templateTypeId === PAGE_ID_SPEED_COURSE) {
//       return acc;
//     }

//     if (page?.hideProgress) {
//       return acc;
//     }

//     // for pictureslides, also count the slides of each pictureslide
//     if (page.templateTypeId === TEMPLATE_PICTURESLIDES) {
//       const slides
//         = index === pageIndex
//           ? page.pictureslides?.slides.slice(0, slideIndex + 1)
//           : page.pictureslides?.slides;

//       return acc + slides.filter(slide => slide && !slide.hideProgress).length;
//     } else if (page.templateTypeId === PAGE_ID_SPEED_COURSE) {
//       return acc;
//     }

//     return acc + 1;
//   }, 0);

//   return pagesAndSubpagesCount;
// };


export const getPageNumberIncludingSubpages = createSelector(
  getPages,
  getPageIndex,
  getActiveSlideIndex,
  (pages, pageIndex, slideIndex) => {
    if (pageIndex === -1) return -1;

    const pagesAndSubpagesCount = pages?.slice?.(0, pageIndex + 1)
      ?.reduce((acc, page, index) => {
        if (!page || page?.templateTypeId === PAGE_ID_SPEED_COURSE || page?.hideProgress) {
          return acc;
        }

        // for pictureslides, also count the slides of each pictureslide
        if (page.templateTypeId === TEMPLATE_PICTURESLIDES) {
          const slides = index === pageIndex
            ? page.pictureslides?.slides?.slice?.(0, slideIndex + 1)
            : page.pictureslides?.slides;

          return acc + slides?.filter?.(slide => slide && !slide.hideProgress).length || 0;
        }

        return acc + 1;
      }, 0);

    return pagesAndSubpagesCount;
  },
);

// export const getActivePageTimeToReadQuestionSec = state => {
//   if (!state.course.data) {
//     return undefined;
//   }
//   const activePage = getActivePage(state);

//   if (!activePage || !(activePage.questionnaire || activePage.picturesQuestionnaire)) {
//     return undefined;
//   }

//   if (activePage.questionnaire && activePage.questionnaire.timeBounds.customTimeBounds) {
//     return activePage.questionnaire.timeBounds.timeToReadQuestionSec;
//   }

//   if (
//     activePage.picturesQuestionnaire
//     && activePage.picturesQuestionnaire.timeBounds.customTimeBounds
//   ) {
//     return activePage.picturesQuestionnaire.timeBounds.timeToReadQuestionSec;
//   }

//   return state.course.data?.speedCourseSettings.timeToReadQuestionSec;
// };

const selectSpeedCourseSettings = state => state.course?.data?.speedCourseSettings;

const selectActiveQuestionnaireCustomTimebounds = createSelector(
  getPage,
  activePage => {
    const {questionnaire, picturesQuestionnaire} = activePage || {};

    if (!questionnaire && !picturesQuestionnaire) return -1;

    if (questionnaire?.timeBounds?.customTimeBounds) return questionnaire.timeBounds;
    if (picturesQuestionnaire?.timeBounds?.customTimeBounds) return picturesQuestionnaire.timeBounds;

    return undefined;
  },
);

export const getActivePageTimeToReadQuestionSec = createSelector(
  selectActiveQuestionnaireCustomTimebounds,
  selectSpeedCourseSettings,
  (customTimeBounds, speedCourseSettings) => {
    if (customTimeBounds === -1) return undefined;

    return customTimeBounds?.timeToReadQuestionSec || speedCourseSettings?.timeToReadQuestionSec;
  },
);

// export const getActivePageTimeToAnswerQuestionSec = state => {
//   if (!state.course.data) {
//     return undefined;
//   }
//   const activePage = getActivePage(state);

//   if (!activePage || !(activePage.questionnaire || activePage.picturesQuestionnaire)) {
//     return undefined;
//   }

//   if (activePage.questionnaire && activePage.questionnaire.timeBounds.customTimeBounds) {
//     return activePage.questionnaire.timeBounds.timeToAnswerQuestionSec;
//   }

//   if (
//     activePage.picturesQuestionnaire
//     && activePage.picturesQuestionnaire.timeBounds.customTimeBounds
//   ) {
//     return activePage.picturesQuestionnaire.timeBounds.timeToAnswerQuestionSec;
//   }

//   return state.course.data?.speedCourseSettings.timeToAnswerQuestionSec;
// };

export const getActivePageTimeToAnswerQuestionSec = createSelector(
  selectActiveQuestionnaireCustomTimebounds,
  selectSpeedCourseSettings,
  (customTimeBounds, speedCourseSettings) => {
    if (customTimeBounds === -1) return undefined;

    return customTimeBounds?.timeToAnswerQuestionSec || speedCourseSettings?.timeToAnswerQuestionSec;
  },
);

const getQuestionnaireResult = ({
  answers = [],
  selectedAnswers = new Set(),
  texts = {},
  redirections = {},
}) => answers
  .map(answer => answer?.isCorrect === Array.isArray(selectedAnswers)
    ? selectedAnswers.includes(answer?.id)
    : selectedAnswers?.has?.(answer?.id))
  .every(Boolean)
  ? {
    isCorrect: true,
    header: getDictionary().ANSWER_CORRECT,
    text: texts.textWhenGood,
    nextPageId: redirections.onSuccessPageId,
  }
  : {
    isCorrect: false,
    header: getDictionary().ANSWER_WRONG,
    text: texts.textWhenWrong,
    nextPageId: redirections.onFailurePageId,
  };

// export const getPageQuestionnairesResults = (state, params = {}) => {
//   if (!state.course.data) {
//     return {};
//   }

//   const {pageId = state.course.data?.activePageId} = params;

//   if ([PAGE_ID_LOADING, PAGE_ID_DESCRIPTION].includes(pageId)) {
//     return null;
//   }

//   const res = state.course.data[pageId]
//     ? Object.fromEntries(Object.entries(state.course.data[pageId])
//       .map(([componentDataKey, {selectedAnswers}]) => ({
//         componentDataKey,
//         selectedAnswers: new Set(selectedAnswers),
//         ...getPage(state, {pageId})[componentDataKey],
//       }))
//       .map(({componentDataKey, ...questionnaireResultParams}) => [componentDataKey, getQuestionnaireResult(questionnaireResultParams)]))
//     : {};

//   console.log('result', {res});

//   return res;
// };

const selectActiveCourseData = createSelector(
  getCourseData,
  getActivePageId,
  (courseData, activePageId) => courseData?.[activePageId],
);

export const getPageQuestionnairesResults = createSelector(
  selectActiveCourseData,
  getActivePageId,
  getPage,
  (activeCourseData, pageId, activePage) => {
    if (!activeCourseData || !Object.keys(activeCourseData).length) {
      return EmptyObject;
    }

    if ([PAGE_ID_LOADING, PAGE_ID_DESCRIPTION].includes(pageId)) {
      return null;
    }

    // const _res = Object.fromEntries(Object.entries(activeCourseData)
    //   .map(([componentDataKey, {selectedAnswers}]) => ({
    //     componentDataKey,
    //     selectedAnswers: new Set(selectedAnswers),
    //     ...activePage[componentDataKey],
    //   }))
    //   .map(({componentDataKey, ...questionnaireResultParams}) => [componentDataKey, getQuestionnaireResult(questionnaireResultParams)]));

    const res = {};

    for (const key of Object.keys(activeCourseData)) {
      res[key] = getQuestionnaireResult({
        selectedAnswers: new Set(activeCourseData?.[key]?.selectedAnswers || []),
        ...activePage?.[key],
      });
    }

    // console.log('GET PAGE QUESTIONNAIRES RESULTS', {res, _res});
    return res;
  },
);

// export const getIsSpeedCoursePage = state => {
//   const pages = getPages(state);
//   const activePageIndex = getPageIndex(state);
//   const speedCoursePageIndex = pages.findIndex(page => page.templateTypeId === PAGE_ID_SPEED_COURSE);

//   return (
//     speedCoursePageIndex !== -1
//     && (activePageIndex === -1 || speedCoursePageIndex <= activePageIndex)
//   );
// };


export const getIsSpeedCoursePage = createSelector(
  getPages,
  getPageIndex,
  (pages, activePageIndex) => {
    const speedCoursePageIndex = pages?.findIndex?.(page => page.templateTypeId === PAGE_ID_SPEED_COURSE) ?? -1;

    return (
      speedCoursePageIndex !== -1
    && (activePageIndex === -1 || speedCoursePageIndex <= activePageIndex)
    );
  },
);


// export const getEndPage = state => {
//   const {course: {data: {resultsPage}}} = state;

//   return resultsPage?.disabled && !getIsSpeedCoursePage(state) ? PAGE_ID_FINISHED : PAGE_ID_RESULTS;
// };

const selectResultsPage = ({course}) => course?.data?.resultsPage;

export const getEndPage = createSelector(
  selectResultsPage,
  getIsSpeedCoursePage,
  (resultsPage, isSpeedCoursePage) => resultsPage?.disabled && !isSpeedCoursePage
    ? PAGE_ID_FINISHED
    : PAGE_ID_RESULTS,
);

// export const getNextPageId = state => {
//   const pages = getPages(state);

//   const pageIndex = getPageIndex(state);
//   const activePageId = getActivePageId(state);

//   const page = getPage(state);
//   const slideIndex = getSlideIndex(state);
//   const {pageId} = page?.gotoPage || pages[pageIndex + 1] || {};

//   if (
//     page?.templateTypeId === TEMPLATE_PICTURESLIDES
//     && slideIndex < page.pictureslides?.slides?.length - 1
//   ) {
//     return page.id;
//   }

//   if (pageId) {
//     return pageId;
//   }

//   if (activePageId === undefined) {
//     return undefined;
//   }

//   if (activePageId === PAGE_ID_LOADING || activePageId === PAGE_ID_DESCRIPTION) {
//     const firstPage = pages.length ? pages[0].id : PAGE_ID_NO_PAGES;

//     return firstPage;
//   }

//   if (activePageId === PAGE_ID_RESULTS || activePageId === PAGE_ID_NO_PAGES) {
//     return PAGE_ID_FINISHED;
//   }

//   if (pages.length > 0 && pageIndex === pages.length - 1) {
//     const endPage = getEndPage(state);

//     return endPage;
//   }

//   const pageQuestionnairesResults = Object.entries(getPageQuestionnairesResults(state)).map(([, result]) => result);

//   return pageQuestionnairesResults.length && pageQuestionnairesResults[0].nextPageId
//     ? pageQuestionnairesResults[0].nextPageId
//     : pages[getPageIndex(state) + 1].id;
// };


export const getNextPageId = createSelector(
  getPages,
  getPageIndex,
  getActivePageId,
  getPage,
  getActiveSlideIndex,
  getEndPage,
  getPageQuestionnairesResults,
  (pages, pageIndex, activePageId, page, slideIndex, endPage, pageQuestionnairesResults) => {
    let {pageId} = page?.gotoPage || pages?.[pageIndex + 1] || {};

    if (page?.pictureslides?.slides?.length) {
      const slide = page.pictureslides.slides[0];

      if (slide?.gotoPage?.pageId) {
        pageId = slide.gotoPage.pageId;
      }
    }

    if (
      page?.templateTypeId === TEMPLATE_PICTURESLIDES
      && slideIndex < (page.pictureslides?.slides?.length || 0) - 1
    ) {
      return page.id;
    }

    if (pageId) return pageId;

    if (activePageId === undefined) return undefined;

    if (activePageId === PAGE_ID_LOADING || activePageId === PAGE_ID_DESCRIPTION) {
      return pages?.length ? pages?.[0]?.id : PAGE_ID_NO_PAGES;
    }

    if (activePageId === PAGE_ID_RESULTS || activePageId === PAGE_ID_NO_PAGES) {
      return PAGE_ID_FINISHED;
    }

    if (pages?.length && pageIndex === pages.length - 1) {
      return endPage;
    }

    const questionnairesResults = Object.entries(pageQuestionnairesResults || {}).map(([, result]) => result);

    return questionnairesResults?.[0]?.nextPageId || pages?.[pageIndex + 1]?.id;
  },
);

// export const getNextSlideId = state => {
//   const pageNumber = getPageNumberIncludingSubpages(state);
//   const pageAndSubpageIds = getPageIdSequenceIncludingSubpages(state);

//   const page = getPage(state);
//   const {slideId} = page?.gotoPage || pageAndSubpageIds[pageNumber] || {};

//   return slideId;
// };

export const getNextSlideId = createSelector(
  getPageNumberIncludingSubpages,
  getPageIdSequenceIncludingSubpages,
  getPage,
  (pageNumber, pageAndSubpageIds, page) => {
    const {slideId} = page?.gotoPage || pageAndSubpageIds?.[pageNumber] || {};

    return slideId;
  },
);

// export const getActivePageInitTimestamp = state => {
//   if (
//     state.course.data
//     && [PAGE_ID_LOADING, PAGE_ID_DESCRIPTION].includes(state.course.data?.activePageId)
//   ) {
//     return null;
//   }

//   const res = state.course.data
//     ? state.course.pagesInitTimestamps[state.course.data?.activePageId]
//     : null;

//   console.log('get active page init timestamp', {res, state, pagesInitTimestamps: state.course.pagesInitTimestamps});

//   return res;
// };

const selectPagesInitTimestamps = state => state.course?.pagesInitTimestamps;

export const getActivePageInitTimestamp = createSelector(
  getActivePageId,
  selectPagesInitTimestamps,
  (activePageId, pagesInitTimestamps) => {
    if (!activePageId || !pagesInitTimestamps || (activePageId === PAGE_ID_LOADING || activePageId === PAGE_ID_DESCRIPTION)) return null;

    return pagesInitTimestamps[activePageId];
  },
);
